import { SortingContextProvider } from 'utils/contexts/sorting';
import { useProjectIdSearchParamOnMount } from 'modules/app/hooks/useInitializeCurrentProject/useProjectIdSearchParamOnMount';
import { PaginationContextProvider } from 'utils/contexts/pagination';
import { ModalContextProvider } from 'utils/contexts/modal';
import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';

import { FiltersContextProvider, ListsContextProvider, SelectionContextProvider } from './contexts';
import { Header, ListPaginationFooter, Filters, ListsTable, ListIndexModals } from './components';
import { LIST_COLUMNS } from './types';

export const ListIndexPage = () => {
  useProjectIdSearchParamOnMount();

  return (
    <SortingContextProvider
      defaultSortField={LIST_COLUMNS.lastModifiedBy}
      defaultSortDirection={SORT_DIRECTIONS.DESCENDING}
    >
      <PaginationContextProvider>
        <FiltersContextProvider>
          <ListsContextProvider>
            <SelectionContextProvider>
              <ModalContextProvider>
                <Header />
                <Filters />
                <ListsTable />
                <ListPaginationFooter />
                <ListIndexModals />
              </ModalContextProvider>
            </SelectionContextProvider>
          </ListsContextProvider>
        </FiltersContextProvider>
      </PaginationContextProvider>
    </SortingContextProvider>
  );
};
